export const languagePL =
    {
        cookieModalTitle:"Ustawienia plików cookies (ciasteczek)",
        cookieModalContext:"Oprócz plików cookie, które są niezbędne do działania tej strony internetowej, używamy następujących rodzajów plików cookie, aby poprawić komfort korzystania z witryny i naszych usług: Funkcjonalne pliki cookie, aby poprawić komfort korzystania z witryny (np. zapamiętać ustawienia), Wydajnościowe pliki cookie, aby zmierzyć wydajność witryny i poprawić komfort korzystania z niej, Reklamowe/targetujące pliki cookie, które są ustawiane przez strony trzecie, z którymi realizujemy kampanie reklamowe i pozwalają nam dostarczać Ci reklamy odpowiednie dla Ciebie. Zapoznaj się z naszą polityką cookies, aby uzyskać więcej informacji.",
        cookieButtonAccept:"Akceptuje wszystkie pliki cookies",
        cookieButtonOptions:"Dostosowanie cookies",
        cookieCheckboxTitle1:"Akceptuję poniższe cookie dotyczące funkcji",
        cookieCheckboxDesc1:"Pliki cookie dotyczące funkcji, dzięki którym możemy zwiększyć Twoją satysfakcję z korzystania ze strony (np. dzięki zapamiętywaniu wybranych przez Ciebie ustawień).",
        cookieCheckboxTitle2:"Akceptuję poniższe cookie dotyczące wydajności strony",
        cookieCheckboxDesc2:"Cookie dotyczące wydajności strony, dzięki którym możemy oceniać jakość strony i zwiększyć Twoją satysfakcję z korzystania ze strony. W trakcie używania cookie dotyczących jakości nie gromadzimy żadnych danych osobowych i wykorzystujemy wyłącznie informacje zebrane za pośrednictwem tych plików w formie zagregowanej i anonimowej.",
        cookieCheckboxTitle3:"Akceptuję poniższe cookie dotyczące reklamy/ targetowania",
        cookieCheckboxDesc3:"Marketingowe/targetujące pliki cookie, których używamy do śledzenia aktywności i sesji użytkownika, abyśmy mogli świadczyć bardziej spersonalizowane usługi. Marketingowe pliki cookie są ustawiane przez strony trzecie, z którymi realizujemy kampanie marketingowe i umożliwiają nam dostarczanie odpowiednich dla Ciebie materiałów marketingowych.",
        cookieOptionsAccept:"Zapisz mój wybór",
        cookieTableHeader:"Funkcjonalne",
        cookieHeading:"Nazwa pliku cookie",
        cookieTableContext:"controlCookie, advertisingCookies, mandatoryCookies, performanceCookies",
        cookieHeading2:"Właściciel pliku cookie",
        cookieTableContext2:"EY",
        cookieHeading3:"Cel pliku cookie",
        cookieTableContext3:"Przechowuje informacje o odpowiedzi użytkownika na temat warunków cookie.",
        cookieHeading4:"Rodzaj pliku cookie",
        cookieTableContext4:"Własne	",
        cookieHeading5:"Okres ważności pliku cookie",
        cookieTableContext5:"30 dni	",
        cookieTableHeader2:"Wydajnosciowe",
        cookieHeading6:"Nazwa pliku cookie",
        cookieTableContext6:"_pk_id.<appID>.<domainHash>",
        cookieTableContext6_2:"pk_ses.<appID>.<domainHash>",
        cookieTableContext6_3:"stg_last_interaction",
        cookieTableContext6_4:"stg_returning_visitor",
        cookieTableContext6_5:"stg_traffic_source_priority",
        cookieHeading7:"Właściciel pliku cookie",
        cookieTableContext7_1:"Piwik",
        cookieTableContext7_2:"Piwik",
        cookieTableContext7_3:"Piwik",
        cookieTableContext7_4:"Piwik",
        cookieTableContext7_5:"Piwik",
        cookieHeading8:"Cel pliku cookie",
        cookieTabContext8_1:"Służy do rozpoznawania gości i przechowywania ich lokalnych danych.",
        cookieTabContext8_2:"Pokazuje aktywną sesję odwiedzającego. Jeśli plik cookie nie istnieje, sesja zakończyła się ponad 30 minut temu i została zliczona w pliku cookie pk_id.",
        cookieTabContext8_3:"Określa, czy sesja ostatniego gościa nadal trwa, czy też rozpoczęła się nowa sesja.",
        cookieTabContext8_4:"Określa, czy odwiedzający był już w Twojej witrynie oraz powrócił.",
        cookieTabContext8_5:"Przechowuje typ źródła ruchu, który wyjaśnia, w jaki sposób odwiedzający dotarł do Twojej witryny.",
        cookieHeading9:"Rodzaj pliku cookie",
        cookieTabContext9_1:"Podmiot zewnętrzny",
        cookieTabContext9_2:"Podmiot zewnętrzny",
        cookieTabContext9_3:"Podmiot zewnętrzny",
        cookieTabContext9_4:"Podmiot zewnętrzny",
        cookieTabContext9_5:"Podmiot zewnętrzny",
        cookieHeading10:"Okres ważności pliku cookie",
        cookieTabContext10_1:"13 miesięcy",
        cookieTabContext10_2:"30 minut",
        cookieTabContext10_3:"365 dni",
        cookieTabContext10_4:"365 dni",
        cookieTabContext10_5:"30 minut",
        cookieTableHeader3:"Reklamowe",
        cookieHeading11:"Nazwa pliku cookie",
        cookieTabContext11_1:"ln_or",
        cookieTabContext11_2:"_gcl_au",
        cookieHeading12:"Właściciel pliku cookie",
        cookieTabContext12_1:"LinkedIn",
        cookieTabContext12_2:"Google",
        cookieHeading13:"Cel pliku cookie",
        cookieTabContext13_1:"Określa, czy można przeprowadzić analizę Oribi na określonej domenie",
        cookieTabContext13_2:"Używane jako tag łączący konwersję w kontenerach internetowych i AMP, które można skonfigurować w celu łączenia danych, gdy strony docelowe i strony konwersji są osadzone w różnych domenach. Wykorzystywane przez Google Adsense",
        cookieHeading14:"Rodzaj pliku cookie",
        cookieTabContext14_1:"Podmiot zewnętrzny",
        cookieTabContext14_2:"Podmiot zewnętrzny",
        cookieHeading15:"Okres ważności pliku cookie",
        cookieTabContext15_1:"1 dzień",
        cookieTabContext15_2:"90 dni",
        cookieOptionsDesc:"Ustawienia cookies",
        loaderTitle:"Proszę czekać...",
        loaderDesc:"Trwa generowanie wyników",
        sucessTitle:"Gotowe",
        successDesc:"Dziękujemy za wypełnienie formularza, potwierdzenie wraz z wynikami wysłaliśmy na maila ",
        buttonBack:"Wróc",
        buttonForward:"Dalej",
        buttonSubmit:"Sprawdź wyniki",
        buttonHomePage:"Powrót na stronę główną"
    }
